import { VatCode } from '@ankor-io/common/types/transaction/transaction'

export const getVatCodeText = (vatCode: VatCode): string => {
  switch (vatCode) {
    case VatCode.VAT_INCLUSIVE:
      return 'Tax Inclusive'
    case VatCode.VAT_EXCLUSIVE:
      return 'Tax Exclusive'
    case VatCode.VAT_NA:
      return 'No Tax'
    default:
      return vatCode
  }
}
